<template>
    <div>
        <modal
            v-if="step === 'validation'"
            id="global_validator_validate_step"
            ref="validateCouponStep"
            :modelValue="isModalOpen"
            @close="handleModalClose"
        >
            <template slot="title">
                <div>
                    <span v-show="valid === false"
                        ><div class="fa fa-warning"></div>
                        {{ t('coupons-invalid_title', { 0: code }) }}
                    </span>
                    <span v-show="valid"
                        ><div class="fa fa-check"></div>
                        {{ t('coupons-utilizing_title', { 0: code }) }}
                    </span>
                </div>
            </template>
            <template slot="body">
                <template v-if="loading">
                    <div style="text-align: center">
                        <span class="far fa-spinner fa-spin fa-3x"></span>
                    </div>
                </template>
                <template v-else>
                    <div class="message message-error" v-if="valid === false">
                        <span v-if="error == 'expired'"
                            >{{ t('coupons-error_expired') }}
                            <human-date
                                :date="errorDate"
                                :format="t('dates-format_date_time_comma')"
                            ></human-date
                        ></span>
                        <span v-if="error == 'not-yet-valid'"
                            >{{ t('coupons-error_not_yet_valid') }}
                            <human-date
                                :date="errorDate"
                                :format="t('dates-format_day_month_short_time')"
                            ></human-date
                        ></span>
                        <span v-if="error == 'used'">{{ t('coupons-error_used') }}</span>
                        <span v-if="error == 'not-found'"
                            >{{ t('coupons-error_not_found') }}</span
                        >
                    </div>
                    <div v-if="valid">
                        <h3 v-if="coupon.discount">{{ coupon.description }}</h3>
                        <p v-else>
                            {{ t('coupons-benefit_prefix') }}
                            <strong>{{ coupon.description }}</strong>
                            <br />
                            {{ t('coupons-irreversible') }}
                        </p>
                        <div
                            class="current-purchase mt-3"
                            v-if="coupon.discount"
                        >
                            <div
                                class="field"
                                v-if="
                                    coupon.discount_type === 'percentile' ||
                                    coupon.min_order_value
                                "
                            >
                                <label>
                                    {{ t('coupons-purchase_value_label') }}
                                </label>
                                <input
                                    type="tel"
                                    ref="valueField"
                                    class="form-control"
                                    :placeholder="t('coupons-order_value_placeholder')"
                                    v-money="money"
                                    v-model="orderValue"
                                />
                            </div>
                            <div
                                class="message message-error mt-2"
                                v-if="
                                    this.coupon.min_order_value &&
                                    this.floatOrderValue <
                                        this.coupon.min_order_value
                                "
                            >
                                <small
                                    >{{ t('coupons-min_value_error', { 0: this.coupon.min_order_value }) }}</small
                                >
                            </div>
                        </div>
                        <div
                            class="discount-result mt-3"
                            v-if="
                                coupon.discount &&
                                floatOrderValue &&
                                isOrderValueValid
                            "
                        >
                            <span v-if="coupon.discount_type === 'percentile'"
                                >{{ t('coupons-discount_label', { 0: floatOrderValue * (coupon.discount / 100) }) }}</span
                            >
                            <span v-else
                                >{{ t('coupons-discount_label', { 0: coupon.discount }) }}</span
                            >
                        </div>
                    </div>
                </template>
            </template>
            <template slot="footer">
                <div>
                    <button
                        type="button"
                        ref="btnClose"
                        class="btn btn-success"
                        @click="isModalOpen = false"
                    >
                        {{ t('coupons-close_button') }}
                    </button>
                    <button
                        type="button"
                        ref="btnConfirm"
                        class="btn btn-primary"
                        @click="confirmCoupon()"
                        :disabled="!isOrderValueValid"
                    >
                        {{ t('coupons-confirm_button') }}
                    </button>
                </div>
            </template>
        </modal>
        <modal
            v-if="step === 'used'"
            id="global_validator_used_step"
            ref="validateCouponStep"
            :modelValue="isModalOpen"
            @close="handleModalClose"
        >
            <template slot="title">
                <div>
                    <span v-show="valid"
                        ><div class="fa fa-check"></div>
                        {{ t('coupons-used_title', { 0: code }) }}
                    </span>
                </div>
            </template>
            <template slot="body">
                <template v-if="loading">
                    <div style="text-align: center">
                        <span class="far fa-spinner fa-spin fa-3x"></span>
                    </div>
                </template>
                <template v-else>
                    {{ t('coupons-used_success', { 0: coupon.description || coupon.text }) }} <br />
                    {{ t('coupons-used_invalid_now', { 0: code }) }}
                </template>
            </template>
            <template slot="footer">
                <div>
                    <button
                        type="button"
                        ref="btnClose"
                        class="btn btn-success"
                        @click="isModalOpen = false"
                    >
                        {{ t('coupons-close_button') }}
                    </button>
                </div>
            </template>
        </modal>
    </div>
</template>
<style scoped>
.discount-result {
    background: #eee;
    padding: 10px 15px;
    margin: -16px;
    font-weight: 500;
    font-size: 16px;
}
.message-error {
    color: #e5322c;
}
h3 {
    font-size: 18px;
}
strong {
    font-weight: 500;
}
</style>
<script>
import store from "../store";
import keviApi from "../keviApi";
import Vue from "vue";

store.registerModule("coupons", {
    namespaced: true,
    state: {
        step: "",
        code: "",
        error: null,
        errorDate: null,
        valid: false,
        used: false,
        loading: false,
        usedCoupons: 0,
        coupon: {
            code: null,
            used: null,
            created: null,
            expiration_date: null,
            valid_from: null,
            coupons_id: null,
            clients_id: null,
            used_date: null,
            validated_by_users_id: null,
            used_at_places_branches_id: null,
            automations_executions_steps_id: null,
            discount: null,
            discount_type: null,
            plugins_places_id: null,
            min_order_value: null,
            external_id: null,
            places_id: null,
            description: null,
        },
    },
    getters: {
        code: (state) => () => {
            return state.code;
        },
    },
    actions: {
        validateCode({ state, commit }, code) {
            commit("reset");
            commit("setCode", code);
            commit("setStep", "validation");
            commit("setLoading", true);
            var options = keviApi.getOptions("coupons/" + code + "/is-valid");
            window.mixpanel?.track("Coupon - is valid begin", { code: code });
            Vue.http(options).then(function (response) {
                if (response.status === 200) {
                    if (response.body.status === "valid") {
                        commit("setValid", true);
                        const coupon = response.body.coupon;
                        coupon.discount = Number(coupon.discount);
                        coupon.min_order_value = Number(coupon.min_order_value);
                        commit("setCoupon", coupon);
                        commit("setUsed", response.body.coupon.used !== "0");
                    } else {
                        commit("setValid", false);
                        const error = response.body.error;
                        if (error === "not-yet-valid") {
                            commit(
                                "setErrorDate",
                                response.body.valid_from_date,
                            );
                        }
                        if (error === "expired") {
                            commit(
                                "setErrorDate",
                                response.body.expiration_date,
                            );
                        }
                        commit("setError", error);
                    }
                    window.mixpanel?.track("Coupon - is valid success", {
                        valid: this.valid,
                    });
                } else {
                    window.mixpanel?.track("Coupon - is valid error");
                }
                commit("setLoading", false);

                window.mixpanel?.track("Validate Coupon", {
                    client_id: this.coupon.clients_id || null,
                    coupon_code_id: this.coupon.id || null,
                    coupon_id: this.coupon.coupons_id || null,
                    coupon_name: this.coupon.text || null,
                    coupon_code: this.coupon.code || null,
                    coupon_valid_date: this.coupon.expiration_date || null,
                    coupon_used: this.coupon.used || false,
                    coupon_is_valid: this.valid,
                    coupon_state: this.error || "success",
                });
            });
        },
    },
    mutations: {
        reset(state) {
            state.code = null;
            state.used = false;
            state.valid = false;
            state.loading = false;
            state.error = null;
            state.errorDate = null;
            state.step = null;
            state.coupon = {
                code: null,
                used: null,
                created: null,
                expiration_date: null,
                valid_from: null,
                coupons_id: null,
                clients_id: null,
                used_date: null,
                validated_by_users_id: null,
                used_at_places_branches_id: null,
                automations_executions_steps_id: null,
                discount: null,
                discount_type: null,
                plugins_places_id: null,
                min_order_value: null,
                external_id: null,
                places_id: null,
                description: null,
            };
        },
        setStep(state, step) {
            state.step = step;
        },
        setCoupon(state, coupon) {
            state.coupon = coupon;
        },
        setUsed(state, used) {
            state.used = used;
        },
        setValid(state, valid) {
            state.valid = valid;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setCode(state, code) {
            state.code = code;
        },
        setError(state, error) {
            state.error = error;
        },
        setErrorDate(state, errorDate) {
            state.errorDate = errorDate;
        },
        addUsedCoupon(state) {
            state.usedCoupons = state.usedCoupons + 1;
        },
    },
});
export default {
    data: () => ({
        orderValue: null,
        isModalOpen: true,
    }),
    computed: {
        money() {
            return {
                decimal: ",",
                thousands: ".",
                prefix: this.currencySymbol + " ",
                suffix: "",
                precision: 2,
                masked: false /* doesn't work with directive */,
            };
        },
        error: function () {
            return this.$store.state.coupons.error;
        },
        valid: function () {
            return this.$store.state.coupons.valid;
        },
        errorDate: function () {
            return this.$store.state.coupons.errorDate;
        },
        loading: function () {
            return this.$store.state.coupons.loading;
        },
        code: function () {
            return this.$store.state.coupons.code;
        },
        step: function () {
            return this.$store.state.coupons.step;
        },
        coupon: function () {
            return this.$store.state.coupons.coupon;
        },
        isOrderValueValid() {
            if (!this.coupon.discount) {
                return true;
            }
            if (this.floatOrderValue >= this.coupon.min_order_value) {
                return true;
            }
            return false;
        },
        floatOrderValue() {
            if (this.orderValue)
                return parseFloat(
                    this.orderValue
                        .replace(".", "")
                        .replace(",", ".")
                        .replace(/[^0-9.]/gm, ""),
                );
            return 0;
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        reset() {
            this.$store.commit("coupons/reset");
        },
        handleModalClose() {
            this.reset();
        },
        confirmCoupon: function () {
            this.$store.commit("coupons/setLoading", true);
            var options = keviApi.getOptions(
                "coupons/" + this.code + "/use",
                "POST",
                {
                    orderValue: this.floatOrderValue,
                },
            );
            window.mixpanel?.track("Coupon - use confirm", {
                code: this.coupon.code,
            });
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.$store.commit("coupons/setStep", "used");
                    this.$store.commit("coupons/setUsed", 1);
                    const coupon = response.body.coupon;
                    coupon.discount = Number(coupon.discount);
                    coupon.min_order_value = Number(coupon.min_order_value);
                    this.$store.commit("coupons/setCoupon", coupon);
                    if (this.coupon.used) {
                        window.mixpanel?.track("Coupon - use used", {
                            code: this.coupon.code,
                        });
                        this.$store.commit("coupons/addUsedCoupon");
                    }
                    window.mixpanel?.track("Use Coupon", {
                        coupon_name: this.coupon.text,
                        coupon_code: this.coupon.code,
                        coupon_state: this.coupon.used,
                    });
                } else {
                    alert(this.t('coupons-generic_error'));
                }
                this.$store.commit("coupons/setLoading", false);
            });
        },
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    watch: {
        valid(newValid) {
            if (newValid) {
                this.isModalOpen = true;
            }
        },
        code() {
            this.orderValue = 0;
        }
    },
};
</script>
